import React, { Component } from "react";
import api from "../../config/api";
import { connect } from "react-redux";
import {
  debitsSelectedComp,
  debitsSelectedIDsComp,
  valueAmountComp,
  openSnackComp,
  setOpenBankInfos,
  setPaymentDateValue,
  validaDebitsMessage,
} from "../../actions";
import { bindActionCreators } from "redux";
import { withStyles } from "@material-ui/core/styles";
import { Grid } from "@material-ui/core";
import TableSelectedDebits from "../../components/TableSelectedDebits";
import ButtonBack from "../../components/ButtonBack";
import TotalDebtsTextField from "../../components/TotalDebtsTextField";
import ButtonTypeName from "../../components/ButtonTypeName";
import LoadingDefault from "../../components/LoadingDefault";
import ContentNotLoaded from "../../components/ContentNotLoaded";
import { checkDebitsExist } from "../../helper/checkDebitsExist";
import ModalMessage from "../../components/UserMessageHome";
import {
  convertBrazilianDateToISO,
  dateIsValid,
} from "../../helper/convertDate";
import DatePicker from "../../components/DatePicker";
import { b64toBlob } from "../../helper/convertBase64toBlob";
import Messages from "../../helper/resources/Messages";
import { DEBITO_QUITADO } from "../../helper/resources/Constants";
import { isContribuinte } from "../../helper/auth";

const styles = (theme) => ({
  selectDebitsPage: {
    marginTop: 160,
  },
  title: {
    textAlign: "center",
  },
  buttonBack: {
    marginLeft: 35,
  },
  container: {
    padding: "20px 20px",
  },
  inputs: {
    display: "flex",
    width: "50%",
    justifyContent: "flex-end",
    alignItems: "center",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
    },
  },
  inputsItem: {
    width: "initial",
    display: "flex",
    justifyContent: "flex-end",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      justifyContent: "center",
    },
  },
  loadingDiv: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
  },
  datePickerPayment: {
    display: "flex",
    // width: '70%',
    marginLeft: "10px",
    justifyContent: "flex-end",
    alignItems: "center",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
    },
  },
  footerDiv: {
    display: "flex",
    width: "100%",
    margin: "20px 0px 20px 0px",
    justifyContent: "flex-end",
    alignItems: "center",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
    },
  },
});

export class DebitsSelected extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loadingDAM: false,
      loading: false,
      msgSnackbar: "",
      titleMessage: "",
      openModal: false,
      errorCodeDAM: "",
      paymentDateValue: null,
      maxDateAllowed: "",
      dateLoaded: false,
    };

    this.validaDataITIV = this.validaDataITIV.bind();
    this.validaDataITIVExcluir = this.validaDataITIVExcluir.bind();
  }

  componentDidMount() {
    this.setState({
      paymentDateValue:
        this.state.paymentDateValue === null
          ? new Date()
          : this.state.paymentDateValue,
    });
    this.handleGetLastWorkDay();
    checkDebitsExist(this.props);
    this.setState({
      loading: false,
    });
  }

  isContribuinte = () => {
    return isContribuinte({ Perfil: this.props.userProfile });
  };

  handleGetLastWorkDay = async () => {
    try {
      const lastWorkDayDateString = await api.get("Debitos/ultimo-dia-util");
      const date = convertBrazilianDateToISO(lastWorkDayDateString.data);
      const paymentDayDateString = await api.get("Debitos/dia-util");
      const paymentDate = convertBrazilianDateToISO(paymentDayDateString.data);
      const paymenteDateFix = new Date(paymentDate);

      let lastWorkDay = date.split("-");

      var dataLimiteITIV = this.validaDataITIV(null);

      if (dataLimiteITIV !== null) {
        lastWorkDay = dataLimiteITIV.split("-");
        this.props.validaDebitsMessage(
          "Quando selecionado um débito de ITIV, a data de pagamento não pode ser maior que a data de vencimento do ITIV."
        );
      }

      if (lastWorkDay.length > 0) {
        this.setState({
          paymentDateValue: new Date(
            paymenteDateFix.getTime() +
              Math.abs(paymenteDateFix.getTimezoneOffset() * 60000)
          ),
          maxDateAllowed: new Date(
            lastWorkDay[0],
            parseInt(lastWorkDay[1]) - 1,
            lastWorkDay[2].substring(0, 2)
          ),
          dateLoaded: true,
        });
        this.props.setPaymentDateValue(this.state.paymentDateValue);
      }
    } catch (error) {
      this.setState({
        msgSnackbar: "Ocorreu um erro ao carregar as datas para pagamento.",
        dateLoaded: true,
      });
      this.props.openSnackComp(true);
    }
  };

  validaDataITIV = (listDebits) => {
    const debitsSelected = listDebits ?? this.props.debitsSelectedValue;
    var debitosITIV = debitsSelected.filter(
      (item) => item.Tributo.Icone === "ITIV"
    );

    if (debitosITIV.length > 0) {
      var dataLimite = null;

      debitosITIV.forEach((item) => {
        if (dataLimite === null) dataLimite = item.DataVencimentoDiaUtil;

        if (item.DataVencimentoDiaUtil.valueOf() < dataLimite.valueOf())
          dataLimite = item.DataVencimentoDiaUtil;
      });

      return dataLimite;
    } else return null;
  };

  validaDataITIVExcluir = (listaDeletada) => {
    let lastWorkDay = null;
    var dataLimiteITIV = this.validaDataITIV(listaDeletada);
    if (dataLimiteITIV !== null) lastWorkDay = dataLimiteITIV.split("-");

    if (lastWorkDay !== null) {
      this.setState({
        maxDateAllowed: new Date(
          lastWorkDay[0],
          parseInt(lastWorkDay[1]) - 1,
          lastWorkDay[2].substring(0, 2)
        ),
        dateLoaded: true,
      });
      this.props.validaDebitsMessage(
        "Quando selecionado um débito de ITIV, a data de pagamento não pode ser maior que a data de vencimento do ITIV."
      );
    } else {
      this.setState({
        maxDateAllowed: null,
      });
      this.props.validaDebitsMessage("");
    }
  };

  redirectToPaymentMethods = () => {
    const from = {
      pathname: "/formas-pagamento",
      state: { paymentDateValue: this.state.paymentDateValue },
    };
    this.props.history.push(from);
  };

  handleGenerateDAM = async () => {
    this.setState({
      loading: true,
      openModal: false,
    });

    let Ids = this.props.debitsSelectedIDsValue;
    let DataPagamentoDAM = this.state.paymentDateValue;
    let isValidDate = dateIsValid(DataPagamentoDAM);
    let todayDate = new Date().setHours(0, 0, 0, 0);

    try {
      const paidDebits = this.props.debitsSelectedValue.some(
        (e) => e.CodigoSituacao === DEBITO_QUITADO
      );

      if (paidDebits) {
        this.setState({
          msgSnackbar: Messages.DEBITOS_JA_FORAM_QUITADOS,
          loading: false,
        });

        this.props.openSnackComp(true);
      } else if (
        !isValidDate ||
        DataPagamentoDAM < todayDate ||
        DataPagamentoDAM > this.state.maxDateAllowed
      ) {
        this.setState({
          msgSnackbar: Messages.DATA_PAGAMENTO_HOJE_ULTIMO_DIA_MES,
          openModal: true,
        });
        this.props.openSnackComp(true);
      } else {
        let bodyRequest = {
          Ids: Ids,
          DataPagamento: DataPagamentoDAM,
          TipoInscricao: this.props.selectedUser.tipoInscricao,
          Inscricao: this.props.selectedUser.numeroInscricao,
        };

        const DAMResponse = await api.post("Debitos/EmitirDAM", bodyRequest);
        let pdf = "";

        if (DAMResponse.data.EhValida) {
          pdf = DAMResponse.data.Retorno;

          this.setState({
            loading: false,
            openModal: false,
          });

          var file = b64toBlob(pdf, "application/pdf");

          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(file, "DAMPagueFacil.pdf");
          } else {
            var fileURL = URL.createObjectURL(file);
            window.open(fileURL, "_blank");
          }
          this.setState({
            showGenerateDam: true,
            showPaymentOnline: false,
            showAcquirerSelection: false,
            showPaymentSimulation: false,
            showTextGuide: false,
          });
        } else {
          this.setState({
            openModal: true,
            loading: false,
            msgSnackbar: DAMResponse.data.Erros[0],
          });
        }

        if (DAMResponse.data === null || DAMResponse.data === "") {
          this.setState({
            loading: false,
          });
        }
      }
    } catch (error) {
      this.setState({
        loading: false,
      });
    }
  };

  handleMinimumAmount = () => {
    this.setState({
      msgSnackbar: "Você precisa de no mínimo 1 item para gerar o DAM",
    });
    this.props.openSnackComp(true);
  };

  compareDateWithTodayDate = (date) => {
    const today = new Date();
    const { maxDateAllowed } = this.state;

    return today < date && date <= maxDateAllowed;
  };

  handleDateChange = (date, hasError, errorMsg) => {
    if (!hasError) {
      if (this.compareDateWithTodayDate(date)) {
        this.props.setPaymentDateValue(date);
        this.setState({
          paymentDateValue: date,
          msgSnackbar: `Em caso de pagamento de tributo feito após a data de vencimento original,
           o DAM a ser emitido terá seu valor atualizado considerando os encargos cabíveis (atualização monetária,
             juros de mora e multa de mora), que se somarão ao valor original do débito.`,
          titleMessage: "Alteração da data de pagamento",
          openModal: true,
        });
      } else {
        this.setState({
          paymentDateValue: date,
        });
      }
    } else {
      this.setState({
        paymentDateValue: "",
        msgSnackbar: errorMsg,
      });
      this.props.openSnackComp(true);
    }
  };

  closeModal = () => {
    this.setState({ openModal: false });
  };

  render() {
    const { classes } = this.props;
    const {
      loadingDAM,
      errorDAM,
      maxDateAllowed,
      paymentDateValue,
      dateLoaded,
    } = this.state;

    return (
      <div className={classes.selectDebitsPage}>
        {this.state.openModal && (
          <ModalMessage
            userMessage={this.state.msgSnackbar}
            titleMessage={this.state.titleMessage}
            setUserMessageHomeRead={this.closeModal}
            getUserMessageHomeChecked={() => {}}
            modalUserStatusAPI={true}
          />
        )}

        <div className={classes.title}>
          <div className={classes.buttonBack}>
            <ButtonBack link={"/"} />
          </div>
          {/*  <Typography variant="h6" color="textSecondary">
            PAGAMENTO
          </Typography> */}
        </div>
        <div className={classes.selectedDebits}>
          <Grid container className={classes.container}>
            {this.state.loading ? (
              <div className={classes.loadingDiv}>
                <LoadingDefault typeLoading={"card"} />
              </div>
            ) : (
              <TableSelectedDebits
                props={this.props}
                validaDataITIVExcluir={this.validaDataITIVExcluir}
                rows={this.props.debitsSelectedValue}
                handleMinimumAmount={this.handleMinimumAmount}
              />
            )}

            {loadingDAM && (
              <div className={classes.loadingDiv}>
                <LoadingDefault typeLoading={"card"} />
                <p>Gerando o seu DAM</p>
              </div>
            )}

            {errorDAM && (
              <div className={classes.loadingDiv}>
                <ContentNotLoaded message={"Erro na geração do DAM"} />
              </div>
            )}

            <div className={classes.footerDiv}>
              <div className={classes.inputsItem}>
                <TotalDebtsTextField
                  amount={this.props.valueAmountValue}
                  atHomeScreen={false}
                />
              </div>
              <div className={classes.datePickerPayment}>
                {dateLoaded && (
                  <DatePicker
                    DefaultValue={paymentDateValue}
                    MaxDate={maxDateAllowed}
                    OnChangeMethod={this.handleDateChange}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                )}
              </div>
              <div
                className={classes.inputsItem}
                onClick={
                  this.isContribuinte()
                    ? this.redirectToPaymentMethods
                    : this.handleGenerateDAM
                }
              >
                <ButtonTypeName typeButton={this.isContribuinte() ? 16 : 1} />
              </div>
            </div>
            {this.props.messageValidation !== undefined &&
              this.props.messageValidation !== "" && (
                <ContentNotLoaded message={this.props.messageValidation} />
              )}
          </Grid>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (store) => ({
  valueAmountValue: store.cardDebitState.valueAmountValue,
  debitsSelectedValue: store.cardDebitState.debitsSelectedValue,
  messageValidation: store.cardDebitState.messageValidation,
  debitsSelectedIDsValue: store.cardDebitState.debitsSelectedIDsValue,
  selectedUser: store.cardDebitState.selectedUser,
  openBankInfos: store.cardDebitState.openBankInfos,
  userProfile: store.auth.profile,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      debitsSelectedComp,
      debitsSelectedIDsComp,
      valueAmountComp,
      openSnackComp,
      setOpenBankInfos,
      setPaymentDateValue: (date) => dispatch(setPaymentDateValue(date)),
      validaDebitsMessage,
    },
    dispatch
  );

export default withStyles(styles, { withTheme: true })(
  connect(mapStateToProps, mapDispatchToProps)(DebitsSelected)
);
